module.exports = __webpack_public_path__ + "img/Group 88.64ee3686.svg";